<template>
  <div>
    <el-form :inline="true" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="AddGalex">添加</el-button>
      </el-form-item>
    </el-form>
    <el-form :inline="true" :model="formInline">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <!-- <el-form-item>
        <el-input size="small" v-model="formInline.inviter" placeholder="请输入分类Id"></el-input>
      </el-form-item> -->
      <el-form-item label="类型">
        <el-select size="small" v-model="formInline.type" placeholder="请选择类型">
          <el-option v-for="item in typeToken" :label="item.name" :value="item.value"
            :key="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="">
        <el-checkbox v-model="top">顶置</el-checkbox>
        <el-checkbox v-model="carousel">轮播</el-checkbox>
      </el-form-item>

      <el-form-item label="">
        
      </el-form-item>

      

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表  show-summary :summary-method="getSummaries"  -->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column align="center" prop="id" label="id">
      </el-table-column>
      <el-table-column align="center" prop="cId" label="分类Id">
      </el-table-column>
      <el-table-column align="center" prop="cName" label="分类名称">
      </el-table-column>
      <el-table-column align="center" prop="title" label="标题">
      </el-table-column>
      <el-table-column align="center" label="图片">
        <template slot-scope="scope">
          <div class="img_box" :title="scope.row.image">
            <img :src="scope.row.image" />
            <!-- <p><a :href="scope.row.image" target="_blance">{{ scope.row.image }}</a></p> -->
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="视频" width="220">
        <template slot-scope="scope">
          <div class="video_box" v-if="scope.row.video">
            <video :src="scope.row.video" width="200" height="200" controls></video>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="内容">
        <template slot-scope="scope">
          <p class="hp">{{ scope.row.content }}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="type" label="类型">
        <template slot-scope="scope">
          <p>{{  scope.row.type == 'video'?'视频分类':'资讯类型'}}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" label="置顶">
        <template slot-scope="scope">
              <p>{{scope.row.top?'是':'否'}}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="setupTime" label="创建时间">
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 添加 -->
    <el-dialog :title="isEdit ? '编辑' : '添加'" :visible.sync="addGalexVisible" width="30%" @click="addGalexVisible = false">
      <el-form label-width="120px" :model="editForm" :rules="Rules" ref="editForm">
        <el-form-item label="类型" prop="type">
          <el-select size="small" v-model="editForm.type" placeholder="请选择类型">
            <el-option v-for="item in typeToken1" :label="item.name" :value="item.value" :key="item.value"></el-option>
          </el-select>
          <!-- <el-input size="small" v-model="editForm.type" auto-complete="off" placeholder="请输入类型"></el-input> -->
        </el-form-item>
        <el-form-item label="分类" prop="cId" v-if="editForm.type == 'video'">
          <el-select size="small" v-model="editForm.cId" placeholder="请选择分类Id">
            <el-option v-for="item in categoryArr" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input size="small" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="editForm.title" auto-complete="off" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="图片链接" prop="image">
          <el-input size="small" v-model="editForm.image" auto-complete="off" placeholder="请输入图片"></el-input>
          <el-button v-if="isEdit" type="primary" size="mini" @click="onupload()">上传</el-button>
          <input type="file" ref="inputRef" @change="handleFileUpload" accept="image/*" :multiple="false" class="none" />
        </el-form-item>
        <el-form-item label="视频链接" prop="video">
          <el-input size="small" v-model="editForm.video" auto-complete="off" placeholder="请输入视频"></el-input>
          <el-button v-if="isEdit" type="primary" size="mini" @click="onuploadv()">上传</el-button>
          <input type="file" ref="inputRefv" @change="handleFileUpload" accept="video/*" :multiple="false" class="none" />
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input size="small" type="textarea" :autosize="{ minRows: 2, maxRows: 4}"  v-model="editForm.content" auto-complete="off" placeholder="请输入内容"></el-input>
        </el-form-item>
        
        <el-form-item label="置顶">
          <el-radio v-model="editForm.top" :label="true">是</el-radio>
          <el-radio v-model="editForm.top" :label="false">否</el-radio>
        </el-form-item>

        <el-form-item label="轮播">
          <el-radio v-model="editForm.carousel" :label="true">是</el-radio>
          <el-radio v-model="editForm.carousel" :label="false">否</el-radio>
        </el-form-item>

        <el-form-item label="禁用">
          <el-radio v-model="editForm.disable" :label="true">是</el-radio>
          <el-radio v-model="editForm.disable" :label="false">否</el-radio>
        </el-form-item>
        <!-- <el-form-item label="视频" prop="video">
          <el-input size="small" v-model="editForm.video" auto-complete="off" placeholder="请输入视频"></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addGalexVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitUser('editForm')">{{
          isEdit ? '保存' : '添加' }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { mNews, AddNews, UpdateNews, Categorys } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import { upHttp } from '../../api/axiosFun'
export default {
  data() {
    return {
      loading: false, //是显示加载
      // rules表单验证
      formInline: {
        from: 1,
        limit: 10,
        "title": "",
        "cId": "",
        "type": "",
        'carousel':"",
        'top':''
      },
      isImg:null,
      carousel:false,
      top:false,
      isEdit: false,
      addGalexVisible: false,
      editForm: {
        "cId": "",
        "title": "",
        "image": "",
        "video": "",
        "content": "",
        "type": "",
        "top": false,
        "carousel":false,
        "disable":false
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      categoryArr: [],
      Rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        // cId: [{ required: true, message: '请输入分类', trigger: 'blur' }],
        type: [{ required: true, message: '请输入类型', trigger: 'blur' }],
      },
      typeToken:[{name:'无',value:''},{name:'视频类型',value:'video'},{name:'资讯类型',value:'news'}],
      typeToken1:[{name:'视频类型',value:'video'},{name:'资讯类型',value:'news'}]
    }
  },
  // 注册组件
  components: {
    Pagination
},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    if (this.categoryArr.length == 0) {
        Categorys({ from: 1, limit: 100, name: "" })
          .then(res => {
            if (res.code != 0) {
              this.$message({
                type: 'info',
                message: res.message
              })
            } else {
              this.categoryArr = res.data.list
            }
          })
      }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 获取转入列表
    getdata(parameter) {
      this.loading = true
      mNews(parameter)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.list
            // 分页赋值
            // this.pageparm.currentPage = this.formInline.from
            // this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },

    //Galex显示编辑界面
    AddGalex() {
      this.editForm = {
        "cId": "",
        "title": "",
        "image": "",
        "video": "",
        "content": "",
        "type": "",
        "top": false,
        "carousel":false,
        "disable":false
      }
      this.isEdit = false
      this.addGalexVisible = true
    },
    handleEdit(row) {
      this.editForm = {
        "cId": row.cId,
        "title": row.title,
        "image": row.image,
        "video": row.video,
        "content":row.content,
        "type": row.type,
        "top": row.top,
        "disable": row.disable,
        "carousel":row.carousel,
        "id":row.id
      }
      this.isEdit = true
      this.addGalexVisible = true
    },
    // 添加
    submitUser(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.type != 'video'){
            this.editForm.cId = ''
          }
          if(this.editForm.type == 'video' && this.editForm.cId == ''){
            this.$message({
                  type: 'info',
                  message: "请选择类型"
                })
            return
          }
          this.loading = true
          if (this.isEdit) {
            UpdateNews(this.editForm).then(res => {
              this.loading = false
              this.addGalexVisible = false
              if (res.code == 0) {
                console.log(res)
                this.$message({
                  type: 'success',
                  message: '编辑成功！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            }).catch(err => {
              this.addGalexVisible = false
              this.loading = false
              this.$message.error('编辑失败，请稍后再试！')
            })
            return
          }
          AddNews(this.editForm)
            .then(res => {
              this.loading = false
              this.addGalexVisible = false
              if (res.code == 0) {
                console.log(res)
                this.$message({
                  type: 'success',
                  message: '添加成功！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            }).catch(err => {
              this.addGalexVisible = false
              this.loading = false
              this.$message.error('添加失败，请稍后再试！')
            })
        }
      })
    },

    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageSize = parm.pageSize
      this.formInline.from = (parm.currentPage - 1) * (this.pageparm.pageSize) + 1
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    search() {
        this.formInline.carousel = this.carousel?"1":''
        this.formInline.top = this.top?"1":''
        this.getdata(this.formInline)
    },
    // 上传
    async handleFileUpload(event){
      console.log(this.editForm)
      if(this.editForm.cId == ''){
        this.$message({
          type: 'info',
          message: '请选择类型分类'
        })
        return
      }
      // alert(ids.value)
      // 阻止发生默认行为
      console.log(event)
      // event.preventDefault();
      let formData = new FormData()
      let file = event.target.files[0]
      console.log(file)
      // let blob = new Blob([file]);
      formData.append('file', file)
      let res = await upHttp('/api/m/File/Upload/'+this.editForm.cId, formData)
      console.log('res')
      console.log(res)
      if (res && res.code == 0) {
        this.$message({
          type: 'success',
          message: '上传成功！'
        })
        if(this.isImg == 1){
          this.editForm.image = res.data
        }
        if(this.isImg == 2){
          this.editForm.video = res.data
        }
        
      } else {
        this.$message({
          type: 'info',
          message: res.message
        })
      }
    },
    onupload(){
      this.isImg = 1
      this.$refs.inputRef.value = ''
      this.$refs.inputRef.click()
    },
    onuploadv(){
      this.isImg = 2
      this.$refs.inputRefv.value = ''
      this.$refs.inputRefv.click()
    }
  }
}
</script>
  
<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

.hp {
  max-height: 90px !important;
  overflow: auto;
}

.video_box {
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

img {
  width: 50px;
}
.none{display: none;}
</style>
  
   
   


// WEBPACK FOOTER //
// src/views/news/list.vue